/*
  groom.bg dispatch and delivery estimate, shared by the product trust row and the cart.
  Ported from trust row v2.1 (live Refresh 16): Europe/Sofia time; Mon–Fri cutoff 15:00,
  Saturday 11:00, no Sunday dispatch; Bulgarian official non-working days skipped.
  New in v3: an estimated delivery window = 1–2 working days (Mon–Fri, non-holiday) after dispatch.

  Markup hooks (any number on the page):
    [data-gd-title]     "Изпращаме още днес" / "Изпращаме утре" …
    [data-gd-sub]       countdown or holiday note, plus the delivery window
    [data-gd-delivery]  delivery window only, e.g. "вт, 15.09 – ср, 16.09"
    [data-gd-short]     one line for the announcement bar: "Изпращаме още днес при поръчка до 15:00"
                        (11:00 on Saturday), else "Изпращаме утре" / "в понеделник" / after a holiday
*/
(function () {
  if (window.groomDispatch) return;

  // UI text comes from window.groomT (snippets/groom-i18n-js, locale keys groom.dispatch.*); Bulgarian fallbacks.
  function T(key, fallback, vars) {
    var s = (window.groomT && window.groomT['dispatch_' + key]) || fallback;
    for (var k in vars || {}) s = s.split('{' + k + '}').join(vars[k]);
    return s;
  }
  var DAYS = T('days', 'в неделя|в понеделник|във вторник|в сряда|в четвъртък|в петък|в събота').split('|');
  var SHORT = T('short_days', 'нд|пн|вт|ср|чт|пт|сб').split('|');
  // Dispatch cutoff in minutes after midnight per weekday (0 = Sunday); null = no dispatch.
  var CUTOFF = [null, 900, 900, 900, 900, 900, 660];
  // Official non-working days Mon–Sat (Labour Code art. 154), incl. the compensation day
  // when a non-Easter holiday falls on a weekend. 1 Nov is a school holiday only.
  // Covers through 2027: extend yearly (by Dec 2027) and add any bridge days the government declares.
  var HOLIDAYS = {
    '2026-09-22': 1, '2026-12-24': 1, '2026-12-25': 1, '2026-12-26': 1, '2026-12-28': 1,
    '2027-01-01': 1, '2027-03-03': 1, '2027-04-30': 1, '2027-05-01': 1, '2027-05-03': 1,
    '2027-05-04': 1, '2027-05-06': 1, '2027-05-24': 1, '2027-09-06': 1, '2027-09-22': 1,
    '2027-12-24': 1, '2027-12-25': 1, '2027-12-27': 1, '2027-12-28': 1
  };

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dayKey(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function isHoliday(d) { return HOLIDAYS[dayKey(d)] === 1; }
  function isDispatchDay(d) { return CUTOFF[d.getDay()] !== null && !isHoliday(d); }
  function isWorkingDay(d) { var w = d.getDay(); return w >= 1 && w <= 5 && !isHoliday(d); }
  function dateOnly(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function addDaysUntil(d, test) {
    var n = dateOnly(d);
    do { n.setDate(n.getDate() + 1); } while (!test(n));
    return n;
  }

  function sofiaNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Sofia', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    return new Date(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
  }
  function skipsHoliday(from, to) {
    var n = dateOnly(from);
    for (; n < to; n.setDate(n.getDate() + 1)) { if (isHoliday(n)) return true; }
    return false;
  }
  function leftText(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    if (h === 0) return T('min', '{m} мин', { m: m });
    return m === 0 ? T('h', '{h} ч', { h: h }) : T('hm', '{h} ч {m} мин', { h: h, m: m });
  }
  function short(d) { return SHORT[d.getDay()] + ', ' + pad(d.getDate()) + '.' + pad(d.getMonth() + 1); }

  function compute(nowArg) {
    var now = nowArg || sofiaNow();
    var mins = now.getHours() * 60 + now.getMinutes();
    var today = dateOnly(now);
    var cutoff = isDispatchDay(now) ? CUTOFF[now.getDay()] : null;
    var dispatch, title, lead;
    if (cutoff !== null && mins < cutoff) {
      dispatch = today;
      title = T('today', 'Изпращаме още днес');
      lead = T('order_within_html', 'Поръчай в следващите <b>{t}</b>', { t: leftText(cutoff - mins) });
    } else {
      dispatch = addDaysUntil(now, isDispatchDay);
      var days = Math.round((dispatch - today) / 86400000);
      var when = days === 1 ? T('tomorrow', 'утре') : days <= 6 ? DAYS[dispatch.getDay()] : T('on_date', 'на {d}', { d: dispatch.getDate() + '.' + pad(dispatch.getMonth() + 1) });
      title = T('ships', 'Изпращаме {when}', { when: when });
      lead = skipsHoliday(today, dispatch) ? T('holiday', 'Официален празник') : '';
    }
    var d1 = addDaysUntil(dispatch, isWorkingDay);
    var d2 = addDaysUntil(d1, isWorkingDay);
    var delivery = short(d1) + ' – ' + short(d2);
    var short1;
    if (cutoff !== null && mins < cutoff) {
      short1 = T('today_by', 'Изпращаме още днес при поръчка до {time}', { time: pad(Math.floor(cutoff / 60)) + ':' + pad(cutoff % 60) });
    } else {
      short1 = title + (lead ? ' (' + lead.toLowerCase() + ')' : '');
    }
    return {
      short: short1,
      title: title,
      sub: (lead ? lead + ' · ' : '') + T('delivery_html', 'доставка <b>{d}</b>', { d: delivery }),
      delivery: delivery,
      dispatch: dispatch, d1: d1, d2: d2
    };
  }

  function render() {
    var r = compute();
    document.querySelectorAll('[data-gd-title]').forEach(function (el) { el.textContent = r.title; });
    document.querySelectorAll('[data-gd-sub]').forEach(function (el) { el.innerHTML = r.sub; });
    document.querySelectorAll('[data-gd-delivery]').forEach(function (el) { el.textContent = r.delivery; });
    document.querySelectorAll('[data-gd-short]').forEach(function (el) { if (el.textContent !== r.short) el.textContent = r.short; });
  }

  window.groomDispatch = { compute: compute, render: render };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true });
  else render();
  // The sub line carries a live countdown ("2 ч 15 мин"), so this stays a poll.
  setInterval(render, 30000);

  // Morphs can insert hooks that were not on the page before (the cart assurance line
  // appears when the cart stops being empty). Hooks that already exist carry
  // data-morph-keep, so morph.js:235 preserves the text we wrote and only genuinely new
  // nodes need filling.
  //
  // This used to be a MutationObserver on documentElement with subtree:true, which ran its
  // callback on every DOM mutation in the document for the life of the page — every
  // carousel step, every cart morph, every quick-add — to catch a handful of moments the
  // theme already announces. Listen for those moments instead. A morph arriving through
  // some other path just leaves the server-rendered Liquid text in place, which is a
  // correct (if not time-adjusted) string, not an empty node.
  ['shopify:cart:lines-update', 'shopify:cart:view', 'shopify:product:select'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var settle = event.promise || (event.detail && event.detail.promise);
      if (settle && typeof settle.then === 'function') settle.then(render, render);
      else render();
    });
  });
})();
